module.exports = __webpack_public_path__ + "244551e9b08e5c12bad1ca22959df62f.svg";